import { apiJson } from './http'

export function listNodeDefs() {
  return apiJson('/api/v1/nodes/')
}
